export default __webpack_public_path__ + "static/media/resume.3976a83c.pdf";